// extracted by mini-css-extract-plugin
module.exports = {"removable-service":"removable-service-1kwt9GT","x-button":"x-button-1bVCfsK","icon":"icon-25wo0i7","shipping-account-selector":"shipping-account-selector-9TFv0EB"};